import React from 'react';
import { useReactFlow, useStore } from '@xyflow/react';
import { Input, Select } from 'antd';
import { QUEST_TYPES } from '../../types';
import styles from '../../timeline-node-manager.module.css';

type QuestParamsProps = {
  nodeId: string;
};

export default function QuestParams({ nodeId }: QuestParamsProps) {
  const { setNodes } = useReactFlow();
  const node = useStore((state) => state.nodes.find((n) => n.id === nodeId));

  const onChangeParams = (key: string, value: string) => {
    setNodes((nodes) => {
      const updatedNodes = nodes.map((n) =>
        n.id === nodeId
          ? {
              ...n,
              data: {
                ...n.data,
                [key]: value,
              },
            }
          : n
      );

      return updatedNodes;
    });
  };

  if (!node) return null;

  const questTypeOptions = [
    { value: QUEST_TYPES.SEQUENTIAL, label: 'Sequential (Order matters)' },
    { value: QUEST_TYPES.PARALLEL, label: 'Parallel (Any order)' },
  ];

  return (
    <div className={styles.questParams}>
      <div className={styles.questBlockWrapper}>
        <span className={styles.label}>Quest Name:</span>
        <Input
          value={(node.data?.name as any) ?? ''}
          onChange={(e) => onChangeParams('name', e.target.value)}
          className={styles.input}
        />
      </div>
      <div className={styles.questBlockWrapper}>
        <span className={styles.label}>Quest Type:</span>
        <Select
          value={(node.data?.questType as any) ?? QUEST_TYPES.SEQUENTIAL}
          onChange={(value) => onChangeParams('questType', value)}
          options={questTypeOptions}
          className={styles.input}
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
}
